module.exports = __webpack_public_path__ + "img/adi_achla_kartiv_yes.b24c2288.png";